import { useApolloClient } from '@apollo/client/react';

import type { ReportComponentProps } from '@modules/_shared/components/report-editor/ReportEditorContext';
import { useReportContext } from '@modules/_shared/components/report-editor/ReportEditorContext';
import type { CMAReportType } from '@modules/reports/cma-reports/CMAReportEditor/CMAReportEditor';
import { GET_CMA_REPORT_POIS } from '@modules/reports/cma-reports/cmaReportsQueries';
import StepPointsOfInterest from '@modules/reports/shared/StepPointsOfInterest/StepPointsOfInterest';
import { useUpdateCmaReport } from '@modules/reports/shared/utils';

const StepPOICMA = (props: ReportComponentProps) => {
  const client = useApolloClient();
  const [updateCmaReport] = useUpdateCmaReport(
    props.reportId,
    'page-point-of-interest',
  );
  const { data } = useReportContext();
  const cmaReport = data as CMAReportType;

  const includePoiMap = cmaReport?.include_poi_map ?? true;
  const poiMapZoomLevel = cmaReport?.poi_map_zoom_level ?? null;

  return (
    <StepPointsOfInterest
      {...props}
      reportType="cma"
      updateReport={() => updateCmaReport({})}
      refetchQuery={GET_CMA_REPORT_POIS}
      pageId="page-point-of-interest"
      includePoiMap={includePoiMap}
      poiMapZoomLevel={poiMapZoomLevel}
      onIncludePoiMapChange={value => {
        client.cache.modify({
          id: client.cache.identify({
            __typename: 'cma_reports',
            id: props.reportId,
          }),
          fields: {
            include_poi_map: () => value,
          },
        });
        return updateCmaReport({ include_poi_map: value });
      }}
      onPoiMapZoomLevelChange={value => {
        client.cache.modify({
          id: client.cache.identify({
            __typename: 'cma_reports',
            id: props.reportId,
          }),
          fields: {
            poi_map_zoom_level: () => value,
          },
        });
        return updateCmaReport({ poi_map_zoom_level: value });
      }}
    />
  );
};

export default StepPOICMA;
